module.exports = __webpack_public_path__ + "img/ljhg.dbfe8da0.png";